import { Button, Divider, Flex, Modal, Stack } from '@mantine/core'
import './UserSubscriptionCard.css'
import moment from 'moment'
import { useContext, useState } from 'react'
import AppContext from '../../../contexts/AppContext'
import { IconFaceIdError } from '@tabler/icons-react'
import showNotification from '../../../utils/showNotification'

export default function UserSubscriptionCard() {

   const { currentUser, } = useContext(AppContext)
   const subscription = currentUser.subscription
   const IS_INACTIVE = !subscription || !subscription?.is_active

   const [isConfirmModal, setIsConfirmModal] = useState(false)

   const onConfirmModalFunction = () => {

      setIsConfirmModal(false)
      showNotification({
         title: "Mirá tu pestaña!",
         message: "Se ha abierto una nueva pestaña en tu navegador donde podras continuar el procedimiento",
         autoClose: 5000,
         color: "green",
         status: "success",
      })
      window.open(`https://forvet.org/desactivar?email=${currentUser.email}&subscription_id=${subscription.type}`, '_blank', 'noopener,noreferrer');
   }


   return (
      <>
         {isConfirmModal && <Modal opened={isConfirmModal} onClose={() => setIsConfirmModal(false)}

         >
            <Stack align='center'>
               <IconFaceIdError size={80} />
               <p className='UserSubscriptionCard--confirmModalText' >Te vamos a extrañar {currentUser.name}<br />
                  ¿Estás seguro que queres darte de baja al plan actual?</p>

               <Divider w='100%' color='#00000032' />

               <p className='UserSubscriptionCard--confirmModalText--sm' >En caso de continuar, te vamos a redirigir a otra página para completar la acción</p>

               <Flex w='100%' justify='center' gap={16}>
                  <Button variant='outline' onClick={() => setIsConfirmModal(false)} type='button'>Volver</Button>
                  <Button variant='outline' onClick={onConfirmModalFunction} color='red' type='button'>Continuar</Button>
               </Flex>
            </Stack>

         </Modal>}
         <div className='UserSubscriptionCard-main-container'>
            <h4 className='UserSubscriptionCard--titleCard'>
               {IS_INACTIVE ? "¿Todavía no te has suscripto a la comunidad?" : "Tu suscripción de la comunidad está activa"}
            </h4>
            {!IS_INACTIVE
               ? <div className='UserSubscriptionCard-column-container'>
                  <span>Desde: {moment(subscription.startDate).format("D [de] MMMM [de] YYYY")}</span>
                  <span>Válida hasta: {moment(subscription.endDate).format("D [de] MMMM [de] YYYY")}</span>
                  <Button onClick={() => setIsConfirmModal(true)} style={{ textDecoration: "underline" }} color='#ffffffe0' variant='transparent' type='button'>Quiero darme de baja</Button>
               </div>
               : <div className='UserSubscriptionCard-column-container'>
                  <p>
                     ¡No te pierdas de nada! <br /> Accedé a la comunidad sin límites
                  </p>
                  <Button
                     component='a'
                     href='https://forvet.org/comunidad'
                     target='_blank'
                     variant='light'
                     color='#FF7BAC'
                  >
                     Ver planes
                  </Button>
               </div>
            }
         </div>
      </>

   )
}
